
import React, { useEffect, useCallback, useState, useRef } from "react";
import Select from "react-select";
import { fetchProduit, produitAdded } from "../../Redux/produitReduce";
import {
    AddedExcel,
    saveFile,
    checkProduit,
    verifEntete,
} from "../../Redux/budgetReduce";
import { useDispatch } from "react-redux";
import { Button, Card, Form, Container, Row, Col } from "react-bootstrap";
import { verif } from "./verif_Budget";
import { toast, ToastContainer } from "react-toastify";
import { useHistory, useParams } from "react-router-dom";
import SweetAlert from "react-bootstrap-sweetalert";
import { fetchAnnee } from "../../Redux/anneeReduce";

import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';


function extraction_Budget({ client }) {

    const navigate = useHistory();
    const dispatch = useDispatch();

    const [variable, setVariable] = React.useState("");
    const [alert, setAlert] = React.useState(null);
    const [isLoading, setIsLoading] = React.useState(0);
    const [parent, setparent] = React.useState(0);
    const [entities, setEntities] = useState([]);
    const [uploadFile, setUploadFile] = React.useState()
    const [fileName, setFileName] = useState("");
    const [save, setSave] = useState(false);
    const [month, setmonth] = React.useState(0);
    const [year, setyear] = React.useState(0);
    const [readonly, setreadonly] = React.useState(0);

    const saveTableCalled = useRef(false);

    const notify = (type, msg) => {
        if (type === 1)
            toast.success(<strong>{msg}</strong>);
        else
            toast.error(<strong>{msg}</strong>);
    }

    //Produit
    const [produitSelect, setProduitSelect] = React.useState([]);
    const [optionProduit, setOptionProduit] = React.useState([
        {
            value: "",
            label: "Produit",
            isDisabled: true,
        },
    ]);

    //parent
    const [optionsBudget, setBudgetOptions] = React.useState([
        {
            value: "",
            label: "veuillez choisir un parent",
            isDisabled: true,
            style: "placeholder",
        },
    ]);
    const [BudgetSelect, setBudgetSelect] = React.useState({
        value: 0,
        label: "veuillez choisir un parent",
        style: "placeholder",
    });

    //mois
    const [optionsmois, setmoisOptions] = React.useState([
        {
            value: "",
            label: "veuillez choisir un mois",
            isDisabled: true,
            style: "placeholder",
        },
    ]);
    const [moisSelect, setmoisSelect] = React.useState({
        value: 0,
        label: "veuillez choisir un mois",
        style: "placeholder",
    });

    //annee
    const [anneeSelect, setanneeSelect] = React.useState({
        value: 0,
        label: "veuillez choisir une année",
        style: "placeholder",
    });
    const [optionsannee, setanneeOptions] = React.useState([
        {
            value: "",
            label: "veuillez choisir une année",
            isDisabled: true,
            style: "placeholder",
        },
    ]);



    const verifmois = useCallback(
        async (b) => {

            var entities = [
                { id: 1, nom: "F1" }, { id: 2, nom: "F2" }, { id: 3, nom: "F3" }, { id: 4, nom: "F4" }

            ]
            var arOption = [];
            arOption.push({ value: 0, label: "veuillez choisir un mois", style: "placeholder" });
            entities.forEach((a) => {
                arOption.push({ value: a.id, label: a.nom });
                if (a.id === b) {
                    setmoisSelect({ value: a.id, label: a.nom });
                    setmonth(a.id);
                }
            });
            setmoisOptions(arOption);
        },
        [dispatch]
    );


    const verifannee = useCallback(
        async (b) => {
            var Budget = await dispatch(fetchAnnee());
            var entities = Budget.payload;
            var arOption = [];
            arOption.push({ value: 0, label: "veuillez choisir une année", style: "placeholder" });
            const currentYear = new Date().getFullYear();
            entities.forEach((a, index) => {
                arOption.push({ value: a.id, label: a.annee });

                //if (index === entities.length - 1) {
                if (currentYear === parseInt(a.annee)) {
                    setanneeSelect({ value: a.id, label: a.annee });
                    setyear(a.annee);
                }
                //}
            });
            setanneeOptions(arOption);
        },
        [dispatch]
    );



    const exportToexcel = async (info) => {
        const name = "Budget";
        const currentDate = new Date();
    
        const formattedDate = `${currentDate.getFullYear()}-${(currentDate.getMonth() + 1)
            .toString()
            .padStart(2, '0')}-${currentDate.getDate()
            .toString()
            .padStart(2, '0')}`;
    
        const fileName = `${name} ${formattedDate}`;
    
        if (!info || info.length === 0) return;
    
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('data');
    
        // Create columns dynamically from object keys
        const headers = Object.keys(info[0]);
    
        worksheet.columns = headers.map((header) => ({
            header: header,
            key: header,
            width: 20,
        }));
    
        // Add rows
        info.forEach((row) => {
            worksheet.addRow(row);
        });
    
        // Make header bold
        worksheet.getRow(1).font = { bold: true };
    
        // Auto adjust column width
        worksheet.columns.forEach((column) => {
            let maxLength = 10;
            column.eachCell({ includeEmpty: true }, (cell) => {
                const length = cell.value ? cell.value.toString().length : 10;
                if (length > maxLength) {
                    maxLength = length;
                }
            });
            column.width = maxLength + 2;
        });
    
        const buffer = await workbook.xlsx.writeBuffer();
    
        const blob = new Blob([buffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
    
        saveAs(blob, `${fileName}.xlsx`);
    };


    const fileHandler = (e) => {
        let fileObj = e.target.files[0];
        if (fileObj) {
            setUploadFile(fileObj);
            var str = fileObj.name.replace(/[^a-zA-Z0-9,;\-.!? ]/g, "");
            setFileName(str);
        }
    };


    const showTable = useCallback(async () => {
        try {
            if (fileName !== "") {
                const verificationResult = await dispatch(
                    verifEntete({
                        date: year,
                        month: month,
                        fileName: fileName,
                        id_site: client == "/medis" ? 2 : 3
                    })
                );

                if (verificationResult.payload === false) {
          const arrayBody = await new Promise((resolve, reject) => {
            const reader = new FileReader();
        
            reader.onload = async (e) => {
                try {
                    const buffer = e.target.result;
        
                    const workbook = new ExcelJS.Workbook();
                    await workbook.xlsx.load(buffer);
        
                    const worksheet = workbook.worksheets[0]; // First sheet
        
                    const rows = [];
        
                    worksheet.eachRow({ includeEmpty: true }, (row) => {
                        // ExcelJS row.values starts at index 1
                        const rowData = row.values.slice(1);
                        rows.push(rowData);
                    });
        
                    resolve(verif(rows, month, anneeSelect.label));
                } catch (err) {
                    console.error("Error reading Excel file:", err);
                    reject(err);
                }
            };
        
            reader.onerror = (err) => reject(err);
        
            reader.readAsArrayBuffer(uploadFile);
        });

                    if (arrayBody.test === false) {
                        notify(2, "Vérifier les champs de votre fichier excel");
                        window.location.reload();
                    } else {
                        notify(1, "Extraction avec succès");
                        checkProd(arrayBody.array, year);
                    }
                } else {
                    notify(2, "Déjà inséré");
                    setreadonly(0);
                    setIsLoading(0);
                    setBoutonClique(false);
                }
            } else {
                notify(2, "Vérifiez vos données");
            }
        } catch (error) {
            console.error("An error occurred:", error);
        }
    }, [dispatch, fileName]);



    const getproduit = useCallback(async () => {
        var type = await dispatch(fetchProduit({ client }));
        var entities = type.payload;
        var arrayOption = [];
        entities.forEach((e) => {
            arrayOption.push({ value: e.id, label: e.Designation_1, code: e.Code_PCT });
        });
        setOptionProduit(arrayOption);
    }, [dispatch]);



    function deleteLigne(nb) {
        if (entities.length > 1) {
            // Filter produitSelect
            var filteredProduitSelect = produitSelect.filter(function (value, index) {
                return index !== parseInt(nb);
            });

            // Filter entities
            var filteredEntities = entities.filter(function (entity, index) {
                return index !== parseInt(nb);
            });

            setProduitSelect(filteredProduitSelect);
            setEntities(filteredEntities);
            notify(2, "Supprimer avec succès");
        } else {
            notify(2, "Il faut contenir au moins une ligne");
        }
    }


    const checkProd = useCallback(
        async (table, year) => {
            var arrayBody = [];
            dispatch(checkProduit({ table, year })).then((rowsdes) => {
                if (rowsdes !== undefined && rowsdes.payload.length > 0) {
                    var prod = rowsdes.payload;
                    // console.log(table)
                    for (var i = 0; i < prod.length; i++) {
                        // console.log("ggg", prod[i],i)
                        if (
                            prod[i] !== null &&
                            typeof prod[i] !== "undefined" &&
                            prod[i] !== "undefined"
                        ) {
                            // console.log("des", table[i].designation, i)
                            arrayBody.push({
                                idProduit: prod[i][2],
                                designation: prod[i][0],
                                code: prod[i][3],
                                pght: table[i].pght,
                                total: table[i].total,

                                janv: table[i].jan,
                                fev: table[i].fev,
                                mars: table[i].mars,
                                avr: table[i].avril,
                                mai: table[i].mai,
                                juin: table[i].juin,
                                juillet: table[i].juillet,
                                aout: table[i].aout,
                                sept: table[i].sept,
                                oct: table[i].oct,
                                nov: table[i].nov,
                                dec: table[i].dec,
                            });

                        }
                        else {
                            // console.log("des", table[i].designation, i)
                            arrayBody.push({
                                idProduit: null,
                                designation: table[i].designation,
                                code: table[i].code,
                                pght: table[i].pght,
                                total: table[i].total,
                                janv: table[i].jan,
                                fev: table[i].fev,
                                mars: table[i].mars,
                                avr: table[i].avril,
                                mai: table[i].mai,
                                juin: table[i].juin,
                                juillet: table[i].juillet,
                                aout: table[i].aout,
                                sept: table[i].sept,
                                oct: table[i].oct,
                                nov: table[i].nov,
                                dec: table[i].dec,
                            });
                        }
                    }
                    // console.log(arrayBody)
                    setEntities(arrayBody);
                    setIsLoading(2);
                } else {
                    setEntities([]);
                }
            })
        },
        [dispatch]
    );


    const setTable = useCallback(
        async (table, init) => {
            //1 => update table ***** 0 => initialiser table
            var arrayBody = [];
            if (init === 1) {
                table.forEach((value) => {
                    arrayBody.push({
                        idProduit: value.idProduit,
                        designation: value.designation,
                        code: value.code,
                        pght: value.pght,

                        // Ajout des mois
                        janv: value.janv,
                        fev: value.fev,
                        mars: value.mars,
                        avr: value.avr,
                        mai: value.mai,
                        juin: value.juin,
                        juillet: value.juillet,
                        aout: value.aout,
                        sept: value.sept,
                        oct: value.oct,
                        nov: value.nov,
                        dec: value.dec,

                        total: value.total
                    });
                });


                setEntities(arrayBody);
            } else {
                checkProd(table, year);
            }
        },
        [checkProd]
    );


    const removeProduit = useCallback(
        async (list, select, id) => {
            // console.log(list,select,id)
            list[id].idProduit = null;
            list[id].designation = null;
            list[id].code = "";
            select[id] = null;
            setProduitSelect(select);
            setEntities(list);
            setTable(list, 1);

            console.log(entities)
        },
        [setTable]
    );


    const saveTable = useCallback(async (entities, uploadFile, year, month, client) => {

        if (!verifierLigne(entities)) {
            return;
        }

        var verif = true;
        if (entities.length > 0) {
            entities.forEach((data) => {
                if (data.idProduit === null) verif = false;
            });
        } else {
            verif = false;
        }
        if (verif === false) {
            notify(2, "Vérifier vos données!");
        } else {
            if (saveTableCalled.current) return;
            saveTableCalled.current = true
            setSave(true)
            const dataArray = new FormData();
            dataArray.append("file", uploadFile);
            dataArray.append("name", uploadFile.name);

            dispatch(saveFile(dataArray)).then((e) => {
                var filename = e.payload.filename;

                dispatch(
                    AddedExcel({
                        annee: year,
                        mois: month,
                        file: filename,
                        namefile: uploadFile.name,
                        lignes: entities, client
                    })
                ).then((e) => {
                    if (e.payload === true) {
                        notify(1, "Insertion avec succes");
                        setTimeout(() => {
                            window.location.reload();
                        }, 1300);
                    } else {
                        saveTableCalled.current = false
                        setSave(false)
                        notify(2, "Vérifier vos données!");
                    }
                });
            });
        }
    },
        [dispatch]
    );


    function verifierLigne(entities) {

        var idProduitSet = new Set();

        for (var i = 0; i < entities.length; i++) {
            var line = entities[i];

            if (line.idProduit === null) {
                notify(2, "Veuillez choisir un produit " + (i + 1));
                return;
            }

            if (idProduitSet.has(line.idProduit)) {
                notify(2, "Le produit " + line.designation + " est dupliqué ");
                return false;
            }

            idProduitSet.add(line.idProduit);


            if (line.code === null) {
                notify(2, "Veuillez choisir un code " + (i + 1));
                return;
            }



        }


        return true;
    }


    function AjoutLigne(event) {
        var list = [];
        if (entities.length > 0) list = [...entities];
        list[list.length] = {
            idProduit: null,
            designation: null,
            code: null,
            pght: null,
            total: null,
        };
        setEntities(list);
    }


    function listepp() {
        navigate.push(client + "/listBudget");
    }


    const ProdParent = useCallback(
        async (b) => {
            var Budget = await dispatch(fetchProduit());
            var entities = Budget.payload;
            var arOption = [];
            arOption.push({ value: 0, label: "veuillez choisir un parent", style: "placeholder" });
            entities.forEach((a) => {
                arOption.push({ value: a.id, label: a.designation });
                if (a.id === b) {
                    setBudgetSelect({ value: a.id, label: a.designation });
                    setparent(a.id);
                }
            });
            setBudgetOptions(arOption);
        },
        [dispatch]
    );




    const hideAlert = () => {
        setAlert(null);
    };



    useEffect(() => {
        switch (month) {
            case 1:
                setVariable("JANVIER");
                break;
            case 2:
                setVariable("FEVRIER");
                break;
            case 3:
                setVariable("MARS");
                break;
            case 4:
                setVariable("AVRIL");
                break;
            case 5:
                setVariable("MAI");
                break;
            case 6:
                setVariable("JUIN");
                break;
            case 7:
                setVariable("JUILLET");
                break;
            case 8:
                setVariable("AOUT");
                break;
            case 9:
                setVariable("SEPTEMBRE");
                break;
            case 10:
                setVariable("OCTOBRE");
                break;
            case 11:
                setVariable("NOUVEMBRE");
                break;
            case 12:
                setVariable("DECEMBRE");
                break;
            default:
                break;
        }
        getproduit();
        ProdParent(0)
        verifmois()
        verifannee()
    }, []);


    function deleteLigne(id, entities) {
        var list = [...entities];
        if (list.length > 1) {
            entities.splice(parseInt(id), 1);
            setEntities(entities);
            notify(1, "Supprimer avec succes");
        } else {
            notify(2, "il faut contient au moins une ligne");
        }
        hideAlert();
    }


    const confirmMessage = (id, entities) => {
        setAlert(
            <SweetAlert
                style={{ display: "block", marginTop: "-100px" }}
                title="Êtes-vous sûr de supprimer cette ligne ?"
                onConfirm={() => deleteLigne(id, entities)}
                onCancel={() => hideAlert()}
                confirmBtnBsStyle="info"
                cancelBtnBsStyle="danger"
                confirmBtnText="Oui"
                cancelBtnText="Non"
                showCancel
            ></SweetAlert>
        );
    };


    return (

        <>
            <Container fluid className="responsive-BL table-dynamique releve-class">
                <ToastContainer />
                {alert}
                <Row>
                    <Col md="12">
                        <Button
                            id="saveBL"
                            className="btn-wd btn-outline mr-1 float-left"
                            type="button"
                            variant="info"
                            onClick={listepp}
                        >
                            <span className="btn-label">
                                <i className="fas fa-list"></i>
                            </span>
                            Retour à la liste
                        </Button>
                    </Col>


                </Row>

                <Row>
                    <Col md="12">
                        <Card className="strpied-tabled-with-hover">
                            <Card.Header>
                                <Card.Title as="h3" style={{ textAlign: "center", color: "#0077af" }}><strong>{variable}</strong> </Card.Title>
                                <Row>
                                    <Col md="10">
                                        <Card.Title as="h4">Budget</Card.Title>
                                    </Col>
                                    <Col md="2">
                                        <Button
                                            id="saveBL"
                                            className="btn-wd btn-outline mr-1 float-left"
                                            type="button"
                                            variant="info"
                                            onClick={() => {
                                                const mois1 = ["JAN", "FEV", "MARS", "AVRIL", "MAI", "JUIN", "JUILLET", "AOUT", "SEPT", "OCT", "NOV", "DEC"];
                                                const mois2 = [...mois1]; // deuxième bloc identique

                                                // Première ligne : entête principale
                                                const headerRow1 = [
                                                    "Code", "Article", "PGHT",
                                                    ...mois1, "TOTAL"
                                                ];

                                                // Deuxième ligne (exemple vide)
                                                const exampleRow = [
                                                    "", "", "", "",
                                                    ...mois1.map(() => ""),
                                                    "",
                                                ];

                                                exportToexcel([
                                                    headerRow1,
                                                    exampleRow
                                                ]);
                                            }}
                                        >
                                            <span className="btn-label">
                                                <i className="fas fa-upload"></i>
                                            </span>
                                            Télécharger exemple
                                        </Button>
                                    </Col>

                                </Row>

                            </Card.Header>
                            <Card.Body>



                                <Row>
                                    <Col className="pl-1" md="6">
                                        <Form.Group >
                                            <label>Mois</label>
                                            <Select
                                                placeholder="Mois "
                                                className="react-select primary "
                                                classNamePrefix="react-select"
                                                isDisabled={readonly === 1}
                                                value={moisSelect}
                                                onChange={(value) => {
                                                    setmoisSelect(value);
                                                    setmonth(value.value);
                                                }}
                                                options={optionsmois}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col className="pl-1" md="6">
                                        <Form.Group >
                                            <label>Année</label>
                                            <Select
                                                placeholder="Année "
                                                className="react-select primary "
                                                classNamePrefix="react-select"
                                                value={anneeSelect}
                                                isDisabled={readonly === 1}
                                                onChange={(value) => {
                                                    setanneeSelect(value);
                                                    setyear(value.value);
                                                }}
                                                options={optionsannee}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <br></br><br></br>

                                <Form.Group  >
                                    <Form.Control
                                        id="test"
                                        name="file"
                                        type="file" isDisabled={readonly === 1}
                                        accept=".xls, .xlsx"
                                        onChange={(e) => {
                                            fileHandler(e);
                                        }}
                                    ></Form.Control>
                                </Form.Group>

                                <br></br>
                                <br></br>
                                <div className="text-center" style={{ display: month != 0 && fileName != "" ? 'block' : 'none' }}>
                                    <Button
                                        className="btn-wd btn-outline mr-1 float-right budget"
                                        id="blExt"
                                        type="button"
                                        variant="info"
                                        style={{ display: readonly === 0 ? 'block' : 'none' }}
                                        onClick={(v) => {
                                            showTable();
                                            setIsLoading(1)
                                            setreadonly(1)
                                        }}
                                    >
                                        <span className="btn-label">
                                            <i className="fas fa-cogs"></i>
                                        </span>
                                        Extraction
                                    </Button>
                                </div>


                                <div className="loader-container" style={{ display: isLoading === 1 ? 'block' : 'none' }}>
                                    <div className="loader"></div>
                                </div>

                                <Row style={{ display: isLoading === 2 ? 'block' : 'none' }} >
                                    <Col md="12">
                                        <hr></hr>
                                        <br></br>

                                        <div className="div-sample1">
                                            <table className="table">
                                                <thead>
                                                    <tr>
                                                        <th>Index</th>
                                                        <th>Article</th>
                                                        <th>Code</th>
                                                        <th>PGHT</th>

                                                        {/* En-têtes des mois */}
                                                        <th>Janv</th>
                                                        <th>Fév</th>
                                                        <th>Mars</th>
                                                        <th>Avr</th>
                                                        <th>Mai</th>
                                                        <th>Juin</th>
                                                        <th>Juillet</th>
                                                        <th>Août</th>
                                                        <th>Sept</th>
                                                        <th>Oct</th>
                                                        <th>Nov</th>
                                                        <th>Déc</th>

                                                        <th>TOTAL</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {entities.map((row, key) => (
                                                        <tr key={"tr-" + key}>
                                                            <td>{key+1}</td>
                                                            <td>
                                                                {row.idProduit !== null ? (
                                                                    <Form.Group className="desinationProduit">
                                                                        <Form.Control
                                                                            className="green"
                                                                            readOnly
                                                                            value={row.designation}
                                                                            placeholder="Designation"
                                                                            type="text"
                                                                        />
                                                                        <Button
                                                                            onClick={() => {
                                                                                removeProduit(entities, produitSelect, key);
                                                                            }}
                                                                        >
                                                                            <i className="fa fa-trash" />
                                                                        </Button>
                                                                    </Form.Group>
                                                                ) : (
                                                                    <div>
                                                                        {row.designation != null ? (
                                                                            <Form.Group className="desinationProduit">
                                                                                <Form.Control
                                                                                    className="red"
                                                                                    readOnly
                                                                                    value={row.designation}
                                                                                    placeholder="Designation"
                                                                                    type="text"
                                                                                />
                                                                                <Button
                                                                                    onClick={() => {
                                                                                        removeProduit(entities, produitSelect, key);
                                                                                    }}
                                                                                >
                                                                                    <i className="fa fa-trash" />
                                                                                </Button>
                                                                            </Form.Group>
                                                                        ) : (
                                                                            ""
                                                                        )}
                                                                        <Select
                                                                            className="react-select primary custom-react-select"
                                                                            classNamePrefix="react-select"
                                                                            name="Produit"
                                                                            placeholder="Produit"
                                                                            value={produitSelect[key]}
                                                                            onChange={(v) => {
                                                                                var e = entities;
                                                                                var select = produitSelect;
                                                                                e[key].idProduit = v.value;
                                                                                e[key].designation = v.label;
                                                                                e[key].code = v.code;
                                                                                select[key] = v;
                                                                                setProduitSelect(select);
                                                                                setEntities(e);
                                                                                setTable(e, 1);
                                                                            }}
                                                                            options={optionProduit}
                                                                        />
                                                                    </div>
                                                                )}
                                                            </td>

                                                            <td>
                                                                <Form.Group>
                                                                    <Form.Control
                                                                        className="green"
                                                                        value={row.code}
                                                                        placeholder="Code"
                                                                        type="text"
                                                                        readOnly
                                                                    />
                                                                </Form.Group>
                                                            </td>

                                                            <td>
                                                                <Form.Control
                                                                    className="green"
                                                                    value={row.pght}
                                                                    placeholder="Valeur"
                                                                    type="text"
                                                                    onChange={(e) => {
                                                                        var list = [...entities];
                                                                        list[key].pght = e.target.value;
                                                                        setEntities(list);
                                                                        setTable(list, 1);
                                                                    }}
                                                                />
                                                            </td>

                                                            {/* Colonnes mois */}
                                                            <td>{row.janv ?? 0}</td>
                                                            <td>{row.fev ?? 0}</td>
                                                            <td>{row.mars ?? 0}</td>
                                                            <td>{row.avr ?? 0}</td>
                                                            <td>{row.mai ?? 0}</td>
                                                            <td>{row.juin ?? 0}</td>
                                                            <td>{row.juillet ?? 0}</td>
                                                            <td>{row.aout ?? 0}</td>
                                                            <td>{row.sept ?? 0}</td>
                                                            <td>{row.oct ?? 0}</td>
                                                            <td>{row.nov ?? 0}</td>
                                                            <td>{row.dec ?? 0}</td>

                                                            <td>{row.total}</td>

                                                            <td>
                                                                <Button
                                                                    id={"idLigneR_" + key}
                                                                    onClick={(ev) => {
                                                                        confirmMessage(key, entities);
                                                                    }}
                                                                    variant="danger"
                                                                    size="sm"
                                                                    className="text-danger btn-link delete"
                                                                >
                                                                    <i className="fa fa-trash" id={"idLigneR_" + key} />
                                                                </Button>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>

                                        </div>
                                    </Col>

                                    <br></br>
                                    <hr></hr>
                                    <Button
                                        className="btn-fill pull-left"
                                        type="button"
                                        variant="info"
                                        nom="redac"
                                        onClick={(ev) => AjoutLigne()}
                                    >
                                        Ajouter
                                    </Button>
                                    {!save ?
                                        <Col md="12">
                                            <Button
                                                id="saveBL"
                                                className="btn-wd btn-outline mr-1 float-right"
                                                type="button"
                                                variant="info"
                                                onClick={() =>
                                                    saveTable(
                                                        entities,
                                                        uploadFile,
                                                        year,
                                                        month, client
                                                    )
                                                }
                                            >
                                                <span className="btn-label">
                                                    <i className="fas fa-check"></i>
                                                </span>
                                                Enregistrer
                                            </Button>
                                        </Col>
                                        : <div className=" mr-1 float-right">
                                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                            Enregistrement en cours...
                                        </div>}
                                </Row>
                                {/* )} */}

                                <Row style={{ display: isLoading === 0 ? 'block' : 'none' }}>

                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    );
}
export default extraction_Budget;
